module.exports = __webpack_public_path__ + "img/champion.2285fd26.png";